import React, {useEffect} from "react"
import { ReactSVG } from 'react-svg'
import { Link } from "gatsby"
import logo from "./logo.svg"
import { rhythm } from "../utils/typography"

const Layout = ({ location, title, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  let header

  if (location.pathname === rootPath) {
    header = (

        <Link
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          <h1 style={{textIndent: -999999, display: "inline-block"}}>Home</h1>
          <ReactSVG
            beforeInjection={(svg) => {
              svg.classList.add('logoSvg')
              svg.setAttribute('style', 'width: 180px')
            }}
            src={logo}
            alt={`logo`}
            wrapper={`span`}
          />
        </Link>
    )
  } else {
    header = (
        <Link
          className={`logoLink`}
          style={{
            boxShadow: `none`,
            color: `inherit`,
          }}
          to={`/`}
        >
          <ReactSVG
            beforeInjection={(svg) => {
              svg.classList.add('logoSvg')
              svg.setAttribute('style', 'width: 100px')
            }}
            src={logo}
            alt={`logo`}
            wrapper={`span`}
          />
        </Link>
    )
  }
  useEffect(()=> {
      const btn = document.querySelector(".switch input");
      const prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
      const currentTheme = localStorage.getItem("theme");
      if (currentTheme === "dark" ||
        (currentTheme === null && prefersDarkScheme.matches)
      ) {
        if (!document.body.classList.contains("dark-theme")) {
          document.body.classList.toggle("dark-theme");
        }
        btn.checked = true;
      } else if (currentTheme === "light" ||
        (currentTheme === null && !prefersDarkScheme.matches)
      ) {
        if (!document.body.classList.contains("light-theme")) {
          document.body.classList.toggle("light-theme");
        }
        btn.checked = false;
      }
      btn.addEventListener("click", function () {
        document.body.classList.toggle("light-theme");
        document.body.classList.toggle("dark-theme");
        localStorage.setItem("theme",
          document.body.classList.contains("dark-theme")
            ? "dark"
            : "light");
      })
  }, [])
  return (
    <div
      style={{
        marginLeft: `auto`,
        marginRight: `auto`,
        maxWidth: rhythm(24),
        padding: `${rhythm(1.5)} ${rhythm(3 / 4)}`,
      }}
    >
      <header>{header}
        <label className="switch">
          <input type="checkbox"/>
          <span className="slider round"/>
        </label>
      </header>
      <main>{children}</main>
      <footer>
        © {new Date().getFullYear()}, Made with
        {` ♥ `} in Malmö
      </footer>
    </div>
  )
}

export default Layout
